export const css = {
	root: 'YbzgymOh',
	' _key': 'apic-theme/apic/variants/msurv1'
};

export default css;
